import React, { useState } from "react";
import "./Inventory.css";
import { addInventory } from "../../network/api/endpoints";
import db from "../../assets/db/main-db.json";
import Toast from "../../components/common/Toast";
import loader from "../../assets/loader-imagine.gif";

function QcInventory() {
  const [inventoryList, setInventoryList] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    variant: "",
    model: "",
    condition: "",
    purchasePrice: "",
    sellingPrice: "",
    notes: "",
    quantity: "",
    imei_1: "",
    imei_2: "",
  });

  const allBrands = db.brands;
  const [showDetails, setShowDetails] = useState(null);
  const [allModels, setAllModels] = useState([]);
  const [allVariants, setAllVariants] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const allCondition = ["Silver", "Gold", "Platinum"];

  const handleModelChange = (e) => {
    const selectedBrand = e.target.value;
    const models =
      allBrands.find((brand) => brand.name === selectedBrand)?.models || [];
    setAllModels(models);
    setFormData({
      ...formData,
      brand: selectedBrand,
      model: "",
      variant: "",
    });
    setAllVariants([]);
    setSelectedImage(null);
  };

  const handleVariantChange = (e) => {
    const selectedModel = e.target.value;
    const models = allModels.find((model) => model.name === selectedModel);
    setAllVariants(models?.variants || []);
    setSelectedImage(models?.imageUrl || "");
    setFormData({ ...formData, model: selectedModel, variant: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    if (formData.id) {
      // Edit existing item
      setInventoryList(
        inventoryList.map((item) => (item.id === formData.id ? formData : item))
      );
    } else {
      // Add new item
      setInventoryList([...inventoryList, { ...formData, id: Date.now() }]);
    }

    // Reset form after submitting
    setFormData({
      brand: "",
      model: "",
      variant: "",
      condition: "",
      purchasePrice: "",
      sellingPrice: "",
      notes: "",
      quantity: "",
      imei_1: "",
      imei_2: "",
    });
    // setAllModels([]);
    setAllVariants([]);
    setSelectedImage(null);
  };

  const toggleDetails = (index) => {
    setShowDetails(showDetails === index ? null : index);
  };

  const deleteItem = (index) => {
    setInventoryList(inventoryList.filter((_, i) => i !== index));
  };

  const handleFinalSubmit = async () => {
    setIsLoading(true);
    try {
      const addedItems = [];
      for (const item of inventoryList) {
        const addedItem = await addInventory(item);
        addedItems.push(addedItem);
      }
      console.log(addedItems);
      if (addedItems.length > 0) {
        showToastNotification("Data successfully saved and exported!");
      }
      setInventoryList([]);
    } catch (error) {
      console.error("Network error:", error);
      showToastNotification(`Error: ${error.message || error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const showToastNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const handleEdit = (index) => {
    const itemToEdit = inventoryList[index];
    setFormData(itemToEdit);
  };

  return (
    <>
      {isLoading ? (
        <img src={loader} alt="loading" className="w-1/4 self-center" />
      ) : (
        <div className="container">
          <div className="add-inventory text-black">
            <h2>{formData.id ? "Edit Inventory" : "Add Inventory"}</h2>
            <div className="form-group">
              <div style={{ display: "flex", width: "100%" }}>
                <div className="select-side">
                  <select
                    name="brand"
                    onChange={handleModelChange}
                    disabled={true}
                    className="cursor-not-allowed"
                  >
                    <option value="Apple">Apple</option>
                  </select>

                  <select
                    name="model"
                    value={"Iphone 6"}
                    onChange={handleVariantChange}
                    required
                    disabled={true}
                    className="cursor-not-allowed"
                  >
                    <option value="Iphone 6">Iphone 6</option>
                  </select>

                  <select
                    name="variant"
                    value={formData.variant}
                    onChange={handleChange}
                  >
                    <option value="">Select Variant</option>
                    {allVariants.map((variant) => (
                      <option key={variant.variant} value={variant.variant}>
                        {variant.variant}
                      </option>
                    ))}
                  </select>
                  <select
                    name="condition"
                    value={formData.condition}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Condition</option>
                    {allCondition.map((condition) => (
                      <option key={condition} value={condition}>
                        {condition}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="img-side">
                  {selectedImage && <img src={selectedImage} alt="Preview" />}
                </div>
              </div>

              <input
                type="number"
                name="quantity"
                placeholder="Quantity"
                value={formData.quantity}
                onChange={handleChange}
                // onWheel={(e) => e.target.blur()}
                disabled
              />
              <input
                type="text"
                name="notes"
                placeholder="Additional Note"
                value={formData.notes}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />
              <input
                type="number"
                name="purchasePrice"
                placeholder="Purchase Price"
                value={formData.purchasePrice}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />
              <input
                type="number"
                name="sellingPrice"
                placeholder="Selling Price"
                value={formData.sellingPrice}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />
              <input
                type="number"
                name="imei_1"
                placeholder="IMEI No.1"
                value={formData.imei_1}
                onChange={handleChange}
                // disabled={true}
                // className="cursor-not-allowed"
                onWheel={(e) => e.target.blur()}
              />
              <input
                type="number"
                name="imei_2"
                placeholder="IMEI No.2"
                value={formData.imei_2}
                onChange={handleChange}
                // disabled={true}
                // className="cursor-not-allowed"
                onWheel={(e) => e.target.blur()}
              />

              <button onClick={handleSubmit}>
                {formData.id ? "Update" : "Add"}
              </button>
              {showToast && (
                <Toast
                  message={toastMessage}
                  onClose={() => setShowToast(false)}
                />
              )}
            </div>
          </div>

          <div className="inventory-list">
            <h2>Inventory List</h2>
            {inventoryList.map((item, index) => (
              <div key={index} className="inventory-item">
                <div className="item-header">
                  <div
                    className="item-name"
                    onClick={() => toggleDetails(index)}
                  >
                    <span className="toggle-icon">
                      {showDetails === index ? "▼" : "▶"}
                    </span>
                    <span>
                      {item.brand} - {item.model}
                    </span>
                  </div>
                  <div className="flex">
                    <button
                      className="edit-button mr-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>

                    <button
                      className="delete-button"
                      onClick={() => deleteItem(index)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                {showDetails === index && (
                  <div className="item-details">
                    <p>Purchase Price: {item.purchasePrice}</p>
                    <p>Selling Price: {item.sellingPrice}</p>
                    <p>Note: {item.notes}</p>
                    <p>IMEI 1: {item.imei_1}</p>
                    <p>IMEI 2: {item.imei_2}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          marginTop: "-130px",
          marginLeft: "-90px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "110%",
          padding: "15px",
          background:
            "linear-gradient(to right, rgba(255, 0, 0, 0) 5%, #F70D1A 50%, rgba(255, 0, 0, 0) 95%)",
        }}
      >
        <button
          onClick={handleFinalSubmit}
          style={{
            width: "200px",
            backgroundColor: "white",
            color: "black",
            fontSize: "large",
          }}
        >
          Save
        </button>
        {loader && (
          <div
            className="loader"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px 0",
            }}
          />
        )}
      </div>
    </>
  );
}

export default QcInventory;
